module.exports = __webpack_public_path__ + "media/images/vp/icon.sharebutton.red-d2f81841ca7ee831d1e697b6910d1491.svg";